import React from "react";
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 12,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(10px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 14,
    borderRadius: "50%",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 18 / 2,
    opacity: 1,
    backgroundColor: theme.palette.secondary.main,
    boxSizing: "border-box",
  },
}));

/**
 * ToggleSwitch - Un componente de switch iOS-style
 * @param {boolean} checked - Estado del switch
 * @param {function} onChange - Callback cuando cambia el estado
 * @param {boolean} disabled - Si el switch está deshabilitado
 * @param {object} sx - Estilos adicionales de MUI
 */
export const ToggleSwitch = ({ checked, onChange, disabled = false, sx = {}, ...props }) => {
  return (
    <StyledSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
      inputProps={{ "aria-label": "toggle switch" }}
      {...props}
    />
  );
};

export default ToggleSwitch;
